import { service, factories } from 'powerbi-client'

const powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory)

export { powerbi }
export * from 'powerbi-client'
